import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/connexion", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        const home = data.user?.role === "admin" ? "/admin" : data.user?.role === "seller" ? "/vendeur" : "/dashboard";
        window.history.replaceState(null, "", home);
        navigate(home, { replace: true });
      } catch {
        navigate("/connexion", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1B2A4A]">
      <div className="text-center text-white">
        <div className="w-10 h-10 border-2 border-[#E0C173] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-display text-xl">Connexion en cours…</p>
      </div>
    </div>
  );
}
